import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress"; // 进度条
import store from '@/store'

import member from "../page/member/config/routes"; // 会员管理
import orderInfo from "../page/orderInfo/config/routes"; //订单列表
import shopServe from "../page/manage/shopServe/config/routes"; //订单列表
import versionUpdate from "../page/manage/versionUpdate/config/routes"; //版本更新
import pageRoutes from '../page/index'
//datasheet

Vue.use(Router);

//使用钩子函数对路由进行权限跳转
const router = new Router({
  //mode: 'history', //路由模式，取值为history与hash
  routes: [
    {
      path: "/",
      redirect: "/collectMoney"
    },
    {
      path: "/center",
      component: resolve => require(["../page/center/page.vue"], resolve)
    },
    {
      path: "/",
      name: 'Index',
      component: resolve => require(["../page/manage/shopServe/index.vue"], resolve),
      meta: {
        title: "主页"
      },
      children: [
        {
          path: '/manage/shopServeed',
          /* lkl支付放开 */
          component: (resolve) => require(['../page/manage/shopServe/page.vue'], resolve),
          /* 微信支付放开 */
          // component: (resolve) => require(['../page/manage/shopServe/page.vue'], resolve),
          meta: {
            title: '门店服务',
            keepAlive: false,
          },
        },
        {
          path: '/manage/smsSendTotal',
          component: (resolve) => require(['../page/manage/shopServe/smsSendTotal.vue'], resolve),
          meta: {
            title: '缴费记录',
            keepAlive: false,
          },
        },
      ]
    },
    {
      path: "/",
      name: 'Index',
      component: resolve => require(["../page/datas/authManagement/index.vue"], resolve),
      meta: {
        title: "主页"
      },
      children: [
        {
          path: '/dataList/authManagement',
          component: (resolve) => require(['../page/datas/authManagement/page.vue'], resolve),
          meta: {
            title: '角色权限管理',
            keepAlive: false,
          },
        },
        {
          path: '/dataList/authDetails',
          component: (resolve) => require(['../page/datas/authManagement/details.vue'], resolve),
          meta: {
            title: '角色权限详情',
            keepAlive: false,
          },
        },
        {
          path: '/dataList/edit',
          component: (resolve) => require(['../page/datas/authManagement/edit.vue'], resolve),
          meta: {
            title: '角色权限编辑',
            keepAlive: false,
          },
        },
        {
          path: '/dataList/add',
          component: (resolve) => require(['../page/datas/authManagement/add.vue'], resolve),
          meta: {
            title: '角色权限新增',
            keepAlive: false,
          },
        },
      ]
    },
    {
      path: "/",
      name: 'Index',
      component: resolve => require(["../components/publicSidebar.vue"], resolve),
      meta: {
        title: "主页"
      },
      children: [
        {
          path: "/collectMoney",
          component: resolve =>
            require(["../components/common/blank.vue"], resolve),
          meta: {
            title: "收银",
            code: 'createOrder',
          }
        },
        {
          path: "/manage",
          component: resolve =>
            require(["../components/common/blank.vue"], resolve),
          meta: {
            title: "门店",
            code: 'staff',
          }
        },
        {
          path: "/dataList",
          component: resolve =>
            require(["../components/common/blank.vue"], resolve),
          meta: {
            title: "数据",
            code: "shopData"
          }
        },
        {
          path: "/500",
          component: resolve =>
            require(["../components/common/500.vue"], resolve),
          meta: {
            title: "500"
          }
        },
        {
          path: "/404",
          component: resolve =>
            require(["../components/common/404.vue"], resolve),
          meta: {
            title: "404"
          }
        },
        {
          path: "/403",
          component: resolve =>
            require(["../components/common/403.vue"], resolve),
          meta: {
            title: "403"
          }
        },
        
        ...pageRoutes
        
      ]
    },
    {
      path: '/redirect',
      component: resolve =>
        require(["../components/common/redirect.vue"], resolve),
      meta: {
        title: "redirect"
      }
    },
    
    {
      path: "/ssoLogin",
      component: resolve => require(["../components/common/UniqueLogin.vue"], resolve)
    },
    {
      path: '/selApp',
      component: resolve => require(['../components/common/SelApp.vue'], resolve)
    },
    {
      path: "/regist",
      component: resolve =>
        require(["../components/common/regist/Regist.vue"], resolve)
    },
    {
      path: "/sso",
      component: resolve => require(["../components/common/sso.vue"], resolve)
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      path: "/500",
      redirect: "/500"
    },
    {
      path: "/home",
      component: resolve => require(["../components/common/Home.vue"], resolve),
      meta: {
        title: "首页"
      },
      children: [
        ...member,
        ...orderInfo,
        ...shopServe,
        ...versionUpdate,
      ]
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.path != '/ssoLogin') {
    if(!store.getters.AppInfo){
      next('/ssoLogin');
    } else {
      
      next();
    }
  } else {
    next();
  }
  if (to.meta.authShopId) {
    document.title = to.meta.title;
  }
});
router.afterEach(() => {
  NProgress.done();
});
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  console.log(isChunkLoadFailed)
  window.location.reload();
  if (isChunkLoadFailed) {
      console.log("路由进入错误")
      // router.replace(targetPath);
      window.location.reload();
  }
});
export default router;
